import { NavLink } from "react-router-dom";
import { NavItems } from "../../NavItems";

export const Navigation = () => {
	// Recursive function to render navigation items
	const renderNavItems = (items) =>
		items.map(({ path, label, submenu }) => (
			<li
				key={path}
				className="header__nav-item"
			>
				<NavLink
					to={path}
					className="header__nav-link"
				>
					{label}
				</NavLink>
				{submenu && (
					<ul className="submenu">{renderNavItems(submenu)}</ul>
				)}
			</li>
		));

	return (
		<nav className="header__nav">
			<ul className="container header__nav-links">
				{renderNavItems(NavItems)}
			</ul>
		</nav>
	);
};
